import type { SetURLSearchParams } from "react-router-dom";

export function readStringParam(searchParams: URLSearchParams, key: string, fallback = ""): string {
  return searchParams.get(key) ?? fallback;
}

export function readNullableStringParam(searchParams: URLSearchParams, key: string): string | null {
  return searchParams.get(key);
}

export function readBooleanParam(searchParams: URLSearchParams, key: string, fallback = false): boolean {
  const value = searchParams.get(key);
  if (value === null) return fallback;
  return value === "true";
}

export function readNumberParam(searchParams: URLSearchParams, key: string, fallback: number): number {
  const value = searchParams.get(key);
  if (value === null) return fallback;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

type SearchValue = string | number | boolean | null | undefined;

export function patchSearchParams(
  searchParams: URLSearchParams,
  setSearchParams: SetURLSearchParams,
  updates: Record<string, SearchValue>,
): void {
  const next = new URLSearchParams(searchParams);
  Object.entries(updates).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "" || value === false) {
      next.delete(key);
      return;
    }
    next.set(key, String(value));
  });
  setSearchParams(next, { replace: true });
}
